// @flow
import React from 'react';
import { StyledIcon } from './style';

export type SvgComponentProps = {
    className: string,
    icon: string,
    set: 'device' | 'general' | 'weather'
};

/**
 * Renders an icon from one of the icon fonts.
 *
 * `icon` - the character to render representing the font (see src/constants/general-icons.js)
 * `set` - which icon font to render from
 */
const Icon = ({ className, icon, set, ...props }: SvgComponentProps) => (
    <StyledIcon {...props} className={className} set={set}>
        {icon}
    </StyledIcon>
);

export default Icon;



// WEBPACK FOOTER //
// ./src/core/icons/index.js